import { combineReducers } from "redux";
import receiptReducer from "./reducer";

const reducer = combineReducers({
  receiptReducer,
});

export default reducer;
